import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LogOut, User as UserIcon } from "lucide-react";
import NotificationBell from "@/components/NotificationBell";
import ThemeToggle from "@/components/ThemeToggle";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-white dark:bg-[color:var(--sl-card-bg)] border-b border-gray-200/60 dark:border-[color:var(--sl-border)]/70" style={{ transform: "translateZ(0)", WebkitTransform: "translateZ(0)", backfaceVisibility: "hidden", WebkitBackfaceVisibility: "hidden" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-link">
          <img
            src="/brand/swiftlink-logo.png"
            alt="Swiftlink-Africa"
            className="h-14 w-14 object-contain"
            data-testid="brand-logo-img"
          />
          <span className="font-heading text-xl font-bold tracking-tight hidden sm:inline">Swiftlink-Africa</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-home">Accueil</Link>
          <Link to="/envoyer" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-send">Envoyer</Link>
          <Link to="/suivi" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-track">Suivi</Link>
          <Link to="/mes-envois" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-recent">Mes envois</Link>
          <Link to="/faq" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-faq">FAQ</Link>
          <a href="/#support" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-support">Support</a>
          {user && user.role !== "admin" && (
            <Link to="/mes-transactions" className="text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-mine">Compte</Link>
          )}
        </nav>

        <div className="flex items-center gap-3">
          <ThemeToggle />
          <NotificationBell />
          {user ? (
            <>
              <span className="hidden sm:inline-flex items-center gap-2 text-sm text-gray-600">
                <UserIcon size={16} /> {user.name || user.email}
              </span>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm text-[var(--sl-primary)] font-medium hover:underline" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <button
                onClick={async () => { await logout(); navigate("/"); }}
                className="text-sm text-gray-600 hover:text-[var(--sl-primary)] inline-flex items-center gap-1"
                data-testid="logout-btn"
              >
                <LogOut size={16} /> Sortir
              </button>
            </>
          ) : (
            <Link to="/login" className="text-sm text-gray-700 hover:text-[var(--sl-primary)]" data-testid="nav-login">
              Connexion
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
